export const locale = {
  GLOBAL: {
    Title: "Паямак Ленд",
    PostalCode: "Почтовый индекс",
    postalCodes: "Почтовые индексы",
    selectedPostalCodes: "Выбранные почтовые индексы",
    MciNumberCount: "Количество номеров MCI (Hamrah Aval)",
    MtuNumberCount: "Количество номеров MTU (Irancell)",
    TotalCount: "Общее количество",
    Coefficient: "Коэффициент",
    Back: "Назад",
  },
  ERRORS: {
    PhoneIsNotValid: "Номер телефона введён неверно: пример 09101234567",
    InvalidNumber: "Введённое количество некорректно",
    NoSelectedLineNumber: "Выберите отправляющую линию.",
    EmptyText: "Пожалуйста, введите текст сообщения.",
    UnknownError: "Неизвестная ошибка",
    TryAgain: "Пожалуйста, попробуйте позже.",
    NoAccountCharge: "Недостаточно средств на счёте",
    NoAccess: "Нет доступа.",
    PleasebyeAPlane: "Пожалуйста, приобретите тарифный план.",
    PleaseChargeYourAccount: "Пожалуйста, пополните счёт.",
    AccessDenied: "Доступ запрещён.",
    AccessDeniedDescription:
      "Для получения подробностей свяжитесь с поддержкой",
    Error: "Ошибка",
    InvalidText: "Недопустимый текст",
    InvalidTextContainsLink: "Только сервисные линии могут содержать ссылки.",
  },
  INFOS: {
    SuccessSentSms: "Сообщение отправлено",
    SmsRequestInQueue:
      "Ваше сообщение будет отправлено после одобрения администратором",
    SendData: "Информация об отправке",
    CheckData: "Пожалуйста, ознакомьтесь с информацией ниже и подтвердите.",
  },
  TOBE: {
    to: "до ",
    from: "от ",
  },
  FORMS: {
    DestinationPhone: "Номер получателя",
    TestDestinationPhone: "Тестовый номер",
    SourceNumber: "Номер отправителя",
    Text: "Текст",
    CharCount: "Количество символов",
    FarsiCharCount: "Количество персидских символов",
    EnglishCharCount: "Количество латинских символов",
    Send: "Отправить",
    SendTime: "Время отправки",
    SendTest: "Тестовая отправка",
    SendToTestNumber: "Отправить на тестовый номер",
    SmsCount: "Количество SMS",
    SmsLang: "Язык сообщения",
    Add: "Добавить",
    FromFile: "Добавить из файла",
    TestNumber: "Тестовый номер",
    Test: "Тест",
    ServiceRelated: "Сервисная",
    Price: "Цена",
    NumbersCount: "Количество номеров",
    NumbersCountToSend: "Количество номеров для отправки",
    Search: "Поиск",
    Title: "Заголовок",
    RequestTime: "Время запроса",
    RequestInformation: "Информация о запросе",
    CreateNewPhoneBook: "Создать новую телефонную книгу",
  },
  BUTTONS: {
    OK: "Хорошо",
    AccountCharge: "Пополнить счёт",
    Reports: "Отчёты",
    RemoveAll: "Удалить все",
    BuyAPlane: "Купить тариф",
    Accept: "Подтвердить",
    Reject: "Отклонить",
    Yes: "Да",
    No: "Нет",
    Create: "Создать",
    New: "Новый",
    Save: "Сохранить",
    Delete: "Удалить",
    More: "Ещё",
    TryAgain: "Повторить",
    Close: "Закрыть",
    RollBack: {
      back: "Вернуться к предыдущему пользователю",
      goToMainUser: "Вернуться к основному пользователю",
      CurrentUser: "Текущий пользователь",
    },
  },
  DIALOGS: {
    Waiting: "Пожалуйста, подождите",
    RejectItQuestion: "Отклонить?",
    AcceptItQuestion: "Подтвердить?",
    Rejected: "Отклонено",
    Accepted: "Подтверждено",
    Error: "Ошибка",
  },
  CONFIRM: {
    Delete: "Вы уверены, что хотите удалить?",
    DeleteA: "Вы уверены, что хотите удалить {a}?",
    DeleteALL: "Вы уверены, что хотите удалить всё?",
  },
  LANGUAGE: {
    English: "Английский",
    Persian: "Персидский",
  },
  language: {
    selectAll: "Выбрать все",
    lang: {
      fa: "Персидский",
      ar: "Арабский",
      ar_ae: "Арабский (ОАЭ)",
      ar_iq: "Арабский (Ирак)",
      en_US: "Английский (США)",
      en_GB: "Английский (Великобритания)",
      de: "Немецкий",
      fr: "Французский",
      zh_CN: "Упрощённый китайский",
      zh_TW: "Традиционный китайский",
      tr: "Турецкий",
      ru: "Русский",
      hy: "Армянский",
    },
    only_manual_now: "Сейчас доступен только ручной перевод",
    ai_coming_soon: "Перевод с ИИ скоро будет включён",
    got_it: "Понял",
    origin_language: "Исходный язык",
    target_languages: "Целевые языки",
    remove_all: "Удалить все языки",
    translation_method: "Выберите метод перевода",
    manual_translation: "Ручной перевод",
    ai_translation: "Перевод с ИИ",
    coming_soon: "Скоро",
    source_language_updated: "Исходный язык обновлён",
    error_changing_source_language: "Ошибка при смене исходного языка",
    source_language_created: "Создан новый исходный язык",
    languages_saved: "Новые языки сохранены",
    error_saving_languages: "Ошибка сохранения языков",
    error_loading_language: "Ошибка загрузки языка",
    languages_removed: "Удалённые языки",
    new_languages_to_save: "Новые языки для сохранения",
    saved: "Сохранено",
    management_langs: "Управление языками",
    add_langs: "Добавить язык",
    change_language: "Сменить язык",
    visit_card: "Визитная карточка",
    translate_to: "Перевести на",
    main_language: "язык",
    no_languages_available: "Нет доступных языков",
    return_to_default: "Вернуться к языку по умолчанию",
    translate: "Перевести",
    changes_pending: "Ожидание применения изменений",
    apply_changes: "Применить изменения",
    cancel_changes: "Отмена",
  },
  LISTS: {
    NoData: "Нет данных",
    NoDataFound: "Данные не найдены",
    NoDataFoundFor: "Данные для {a} не найдены",
    NoPhoneNumber: "Номера не найдены",
    NoPostalCode: "Почтовый индекс не найден",
    AddANumber: "Добавьте номер",
    City: "Город",
    AddedBefore: "Уже добавлено ранее",
  },
  PAGES: {
    SendSms: "Отправка SMS",
    MapSms: "Отправка по карте",
    PhoneBook: "Телефонная книга",
  },
  MONETARY: {
    Rial: "Риал",
  },
  HINTS: {
    SendMessageTitle:
      "Заголовок — это произвольное название, которое вы можете использовать повторно из ранее отправленных сообщений, чтобы текст автоматически подставился. Заголовок не отправляется в сообщении. Он используется для отчётности и подсказок.",
    SendMessageTime:
      "Время отправки — это время, когда ваше сообщение будет поставлено в очередь на отправку. Учтите, что без одобрения администратора сообщение не будет отправлено.",
    CreatePhoneBook:
      "Это название будет использоваться при отправке SMS для выбора номеров из данной телефонной книги.",
  },
  TOASTS: {
    SuccessCreate: "Успешно создано",
    FailedCreated: "Ошибка при создании",
    SuccessDelete: "Удалено",
    FailedDelete: "Ошибка при удалении",
    SuccessEdit: "Успешно отредактировано",
    FailedEdit: "Ошибка при редактировании",
    AddedSuccess: "Добавлено",
    AddedFailed: "Ошибка при добавлении",
  },
  WALLET: {
    CustomCharge: "Произвольная сумма",
    GateWay: "Платёжный шлюз",
    Price: "Сумма",
    Details: [
      "К введённой сумме будет добавлен налог 9%.",
      "Пожалуйста, внимательно вводите сумму — внесённые средства возврату не подлежат.",
    ],
    noGateWay: "Для вас не настроен платёжный шлюз.",
    PriceNotInRange: "Сумма должна быть от {min} до {max} риалов.",
    Pay: "Оплатить",
    ErrorOnRedirectToGateWay: "Ошибка при переходе на платёжный шлюз",
    ChargeWalletButtonDescription: "Нажмите на кнопку +, чтобы пополнить счёт",
  },
  login: {
    phoneField: {
      placeholderIran: "Начинается с 9 (пример: +98 912 345 6789)",
      placeholderDefault: "Введите номер телефона",
      maxDigitsError: "Максимум {count} цифр!",
      iranMustStartWith9:
        "Иранский мобильный номер должен начинаться с 9 (912…)",
    },
    signup_button: "Зарегистрироваться!",
    forget_password_title: "Забыли пароль",
    register_title: "Бесплатная регистрация",
    login_title: "Вход",
    back: "Назад",
    username_label: "Мобильный телефон / Логин",
    otp_resend_button: "Отправить код повторно",
    password_label: "Пароль",
    password_hint: "Минимум 8 символов",
    name_label: "Имя",
    name_rule: "Минимум 3 символа",
    lastname_label: "Фамилия",
    phone_label: "Мобильный телефон",
    nid_label: "Национальный код",
    parent_phone_label: "Телефон рекомендателя (необязательно)",
    terms_and_conditions_message:
      "Регистрация означает согласие с правилами и условиями терминала рекламы.",
    terms_and_conditions_link: "Правила и условия",
    close: "Закрыть",
    forgot_password_link: "Забыли пароль?",
    change_password: "Сменить пароль",
    register_button: "Зарегистрироваться",
    login_button: "Войти",
    login_with_google: "Войти через Google",
    login_with_sms: "Войти по SMS",
    login_with_password: "Войти по паролю",
    already_registered: "Уже зарегистрированы?",
    login_here: "Войти",
    no_account: "Нет аккаунта?",
    signup_now: "Зарегистрируйтесь сейчас!",
    more_info: "Подробнее",
    text_login: "Вход",
    text_register: "Регистрация",
    required_field: "Обязательное поле.",
    min_8_char: "Минимум 8 символов",
    required: "Это поле обязательно",
    min_3_char: "Минимум 3 символа",
    max_50_char: "Максимум 50 символов",
    no_internet: "Нет подключения к интернету",
    no_phone_entered: "Вы не ввели номер телефона",
    otp_sent_successfully: "Код подтверждения успешно отправлен.",
    please_register_first: "Пожалуйста, сначала зарегистрируйтесь!",
    wait_3_min: "Пожалуйста, подождите 3 минуты и попробуйте снова.",
    login_successful: "Вы успешно вошли",
    internet_connection_error: "Проблема с подключением к интернету!",
    agree_to_terms_error: "Вы не приняли правила и условия!",
    otp_sent_successfully_register: "Код подтверждения успешно отправлен.",
    error: "Ошибка",
    registration_nid_required_notice:
      "Для обеспечения высокого уровня безопасности и предотвращения мошенничества (фишинга) и злоупотреблений системой, ввод национального кода при регистрации в терминале рекламы обязателен.",
  },
  home: {
    title: "Главная",
    selectSystem: "Выбрать систему",
    yourPoints: "Ваши баллы",
    discountCodes: "Промокоды",
    all: "Все",
    discounts: "Скидки",
    systemGuide: "Руководство по системе",
    yourPointsDynamic: "Ваши баллы: {points}",
    confirm: "Подтвердить",
    copy: "Копировать",
  },
  badges: {
    free: "Бесплатно",
    preRegister: "Предварительная регистрация",
    comingSoon: "Скоро",
    testVersion: "Тестовая версия",
  },
  services: {
    qrLand: {
      title: "Система QR Land",
      description: "Создание динамических QR-кодов",
      property: {
        0: "Анализ и выбор типа и места рекламы",
        1: "Анализ и выбор рекламы в кинотеатрах",
        2: "Без комиссии и дополнительных платежей",
        3: "Единое управление всей рекламой в кинотеатрах",
      },
    },
    payamak: {
      title: "Система Паямак Ленд",
      description: "Массовая рекламная рассылка SMS",
      property: {
        0: "Массовая отправка SMS",
        1: "Актуальная база номеров",
        2: "Отправка SMS клиентскому клубу",
        3: "Интеграция со всеми сайтами и программами",
      },
    },
    robot: {
      title: "Система Robot Land",
      description:
        "Одновременное управление всеми номерами, объявлениями и панелями",
      property: {
        0: "Групповая и массовая регистрация объявлений",
        1: "Таймированное, поэтапное и умное управление объявлениями",
        2: "Аренда и добавление неограниченного количества номеров",
        3: "Одновременная регистрация и управление всеми объявлениями",
      },
    },
    infoLand: {
      title: "Info Land",
      description: "Более 2500 актуальных баз данных профессий",
      property: {
        0: "Все профессиональные данные",
        1: "Классификация по городам и провинциям",
        2: "База данных всех профессий страны",
        3: "Возможность просмотра образцов всех баз",
      },
    },
    graphic: {
      title: "Система Graphic Land",
      description: "Графический и видео-дизайн от 0 до 100",
      property: {
        0: "Дизайн логотипа и фирменного стиля",
        1: "Все услуги печати и упаковки",
        2: "Дизайн каталогов, брошюр и коробок",
        3: "Дизайн и печать баннеров любых размеров",
      },
    },
    bestWebLand: {
      title: "Система Best Web Land",
      description: "Дизайн, поддержка и SEO сайтов",
      property: {
        0: "SEO контента",
        1: "Внешнее SEO (off-page)",
        2: "Техническое SEO",
        3: "Внутреннее SEO (on-page)",
      },
    },
    onlineShop: {
      title: "Конструктор интернет-магазинов",
      description: "Всего несколько кликов до цифрового мира",
      badge: "Партнёрские продажи",
      property: {
        0: "SEO контента",
        1: "Внешнее SEO (off-page)",
        2: "Техническое SEO",
        3: "Внутреннее SEO (on-page)",
      },
    },
    social: {
      title: "Реклама в социальных сетях",
      description: "Анализ и выбор лучших страниц и каналов",
      property: {
        0: "Анализ всех популярных страниц",
        1: "Единое управление всей рекламой",
        2: "Без комиссии и дополнительных платежей",
        3: "Онлайн-заказ рекламы на понравившихся страницах",
      },
    },
    billboard: {
      title: "Онлайн-аренда билбордов",
      description: "Прямая связь без посредников с целевым подбором",
      property: {
        0: "Анализ места и типа билборда",
        1: "Управление всеми арендуемыми билбордами",
        2: "Прямой контакт с владельцем без посредников",
        3: "Без комиссии и дополнительных платежей",
      },
    },
    internationalMedia: {
      title: "Реклама в национальных СМИ",
      description: "Размещение рекламы на ТВ и радио",
      property: {
        0: "Выбор времени выхода рекламы",
        1: "Выбор типа телевизионной рекламы",
        2: "Выбор типа радиорекламы",
        3: "Реклама в конкретных телепрограммах",
      },
    },
    transport: {
      title: "Реклама в транспорте",
      description: "Аэропорты, вокзалы, автобусы и метро",
      property: {
        0: "Анализ и выбор типа и места рекламы",
        1: "Анализ рекламы в метро",
        2: "Без комиссии и дополнительных платежей",
        3: "Единое управление всей рекламой в метро",
      },
    },
    cinema: {
      title: "Реклама в видеомедиа",
      description: "Размещение в кинотеатрах и видеостриминговых сервисах",
      property: {
        0: "Анализ и выбор типа и места рекламы",
        1: "Анализ рекламы в кинотеатрах",
        2: "Без комиссии и дополнительных платежей",
        3: "Единое управление всей рекламой в кинотеатрах",
      },
    },
    estate: {
      title: "Онлайн-система недвижимости",
      description: "Управление объектами, консультантами и клиентами",
      property: {
        0: "Анализ и выбор типа и места рекламы",
        1: "Анализ рекламы в кинотеатрах",
        2: "Без комиссии и дополнительных платежей",
        3: "Единое управление всей рекламой в кинотеатрах",
      },
    },
    AIGeneration: {
      title: "Система искусственного интеллекта",
      description: "Генерация изображений, чат-боты",
    },
    ShortLink: {
      title: "Система коротких ссылок",
      description: "Создание коротких ссылок",
    },
    customer: {
      title: "Система онлайн-управления клиентами",
      description: "Управление, поддержка и создание лояльных клиентов",
      property: {
        0: "Анализ и выбор типа и места рекламы",
        1: "Анализ рекламы в кинотеатрах",
        2: "Без комиссии и дополнительных платежей",
        3: "Единое управление всей рекламой в кинотеатрах",
      },
    },
    internetBroadcasting: {
      title: "Размещение и управление интернет-рекламой",
      description: "Google Ads, кликовая реклама, нативная реклама",
      property: {
        0: "Анализ и выбор типа и места рекламы",
        1: "Анализ рекламы в кинотеатрах",
        2: "Без комиссии и дополнительных платежей",
        3: "Единое управление всей рекламой в кинотеатрах",
      },
    },
    emailMarketing: {
      title: "Система email-маркетинга",
      description: "Рекламная рассылка по всем бизнесам страны",
      property: {
        0: "Анализ и выбор типа и места рекламы",
        1: "Анализ рекламы в кинотеатрах",
        2: "Без комиссии и дополнительных платежей",
        3: "Единое управление всей рекламой в кинотеатрах",
      },
    },
    adsOnStudium: {
      title: "Реклама на стадионах и выставках",
      description: "Присутствие вашего бренда в крупнейших центрах",
      property: {
        0: "Анализ и выбор типа и места рекламы",
        1: "Анализ рекламы в кинотеатрах",
        2: "Без комиссии и дополнительных платежей",
        3: "Единое управление всей рекламой в кинотеатрах",
      },
    },
    bidOnline: {
      title: "Комплексная система онлайн-аукционов",
      description: "Проводите аукционы онлайн, участвуйте в них",
      property: {
        0: "Анализ и выбор типа и места рекламы",
        1: "Анализ рекламы в кинотеатрах",
        2: "Без комиссии и дополнительных платежей",
        3: "Единое управление всей рекламой в кинотеатрах",
      },
    },
    onlineTools: {
      title: "Система онлайн-инструментов для бизнеса",
      description: "Все вспомогательные инструменты для любого бизнеса",
      property: {
        0: "Анализ и выбор типа и места рекламы",
        1: "Анализ рекламы в кинотеатрах",
        2: "Без комиссии и дополнительных платежей",
        3: "Единое управление всей рекламой в кинотеатрах",
      },
    },
    onlineLearn: {
      title: "Система онлайн-обучения профессиям",
      description: "Целевой анализ и выбор курсов",
      property: {
        0: "Анализ и выбор типа и места рекламы",
        1: "Анализ рекламы в кинотеатрах",
        2: "Без комиссии и дополнительных платежей",
        3: "Единое управление всей рекламой в кинотеатрах",
      },
    },
    cloud: {
      title: "Хостинг и покупка доменов",
      description: "Покупка хостинга, домена и серверов",
      property: {
        0: "Анализ и выбор типа и места рекламы",
        1: "Анализ рекламы в кинотеатрах",
        2: "Без комиссии и дополнительных платежей",
        3: "Единое управление всей рекламой в кинотеатрах",
      },
    },
    QrlandShop: {
  title: "Управление интернет-магазинами",
  description: "Комплексное управление товарами, маркетплейсами и интеллектуальным ценообразованием",
  property: {
    0: "Комплексный мониторинг и управление товарами",
    1: "Управление вариантами товаров",
    2: "Мониторинг и управление маркетплейсами",
    3: "Стратегии интеллектуального ценообразования",
  },
},

  },
  "planning.title": "Планирование",
  "tabs.reminder": "Напоминания",
  "tabs.notes": "Заметки",
  "tabs.calendar": "Календарь",
  "notes.creationDate": "Дата создания",
  "common.save": "Сохранить",
  "common.cancel": "Отмена",
  "actions.quickActions": "Быстрые действия",
  "notes.writeMessage": "Написать сообщение",
  "notes.titlePlaceholder": "Заголовок заметки",
  "notes.addNote": "Добавить заметку",
  "notes.updatedSuccess": "Заметка успешно обновлена.",
  "notes.addedSuccess": "Заметка успешно добавлена.",
  "common.deletedSuccess": "Успешно удалено",
  "common.confirmDelete": "Вы уверены, что хотите удалить?",
  "news.title": "Новости сайта",
  "news.noNews": "На сайте нет новостей.",
  "news.view": "Просмотреть",
  "remember.add": "Создать напоминание",
  "remember.update": "Обновить напоминание",
  "remember.titleLabel": "Заголовок",
  "remember.dateLabel": "Дата напоминания",
  "remember.confirmDelete": "Вы уверены, что хотите удалить?",
  "remember.deleteSuccess": "Напоминание успешно удалено.",
  "remember.createSuccess": "Новое напоминание создано.",
  "remember.updateSuccess": "Напоминание обновлено.",
  "points.receivedAwards": "Полученные награды",
  "points.pointsHistory": "История баллов",
  "points.points": "Баллы",
  "points.discountTitle": "Скидка Robot Land",
  "points.discountText": "За каждые 500 баллов",
  events: {
    title: "События",
    addEvent: "Добавить событие",
    calendar: "Базовый календарь",
    close: "Закрыть",
    save: "Сохранить",
    update: "Обновить",
    confirmDelete: "Вы уверены, что хотите удалить?",
    successAdd: "Успешно добавлено.",
    successDelete: "Событие успешно удалено.",
    successUpdate: "Успешно обновлено.",
    titleLabel: "Заголовок",
    descriptionLabel: "Описание",
    colorLabel: "Цвет",
    removeAfterDrop: "После завершения",
    createEvent: "Создать событие",
  },
  copySuccess: "Успешно скопировано.",
  copyTextTitle: "Копировать",
  copiedTextTitle: "Скопировано",
  ribbon: {
    new: "Новое",
  },
  coupons: [
    {
      text: "Этот купон действителен 3 недели",
      title: "Уникальный текст 20%",
    },
    {
      text: "Этот купон действителен 2 недели",
      title: "Дизайн сайта 5%",
    },
    {
      text: "Этот купон можно использовать только один раз",
      title: "Управление страницей 10%",
    },
    {
      text: "Этот купон активирован для вас навсегда",
      title: "Графический дизайн 5%",
    },
    {
      text: "Этот купон можно использовать только один раз",
      title: "Печать 2%",
    },
  ],
  userLinks: {
    profile: {
      title: "Обзор",
      invitation: { title: "Пригласить друзей" },
      info: { title: "Личная информация" },
      edit: { title: "Завершить профиль" },
      changePass: { title: "Сменить пароль" },
    },
  },
  profileLinks: {
    orders: "Заказы",
    addresses: "Адреса",
  },
  customPage: {
    overview: "Обзор",
    personalInfo: "Личная информация",
    changePassword: "Смена пароля",
    completeProfile: "Завершение профиля",
    email: "Электронная почта",
    balance: "Баланс",
    phone: "Номер телефона",
    rial: "Риал",
  },
  widget12: {
    inviteFriends: "Пригласить друзей",
    viewInvitedUsers: "Посмотреть список приглашённых вами пользователей",
    yourInviteCode: "Ваш код приглашения",
    createNewUser: "Создать нового пользователя",
    copyText: "Копировать",
    userCreatedSuccess: "Новый пользователь успешно создан",
    notCreated: "Не создано",
  },
  userInfo: {
    userInformation: "Информация о пользователе",
    profilePicture: "Фото профиля",
    allowedFileTypes: "Разрешённые типы файлов: png, jpg, jpeg.",
    profilePictureSize:
      "Фото профиля должно быть квадратным (например: 480 × 480).",
    firstName: "Имя",
    lastName: "Фамилия",
    username: "Логин",
    phone: "Контактный номер",
    email: "Электронная почта",
    receiveSMS: "Получать SMS",
    smsCostNote:
      "При включении этой опции стоимость отправки SMS будет списываться с вашего счёта.",
    saveChanges: "Сохранить изменения",
    profileUpdated: "Профиль успешно обновлён.",
  },
  emailSettings: {
    completeProfile: "Завершить профиль",
    completeProfileDesc: "Заполните личные или организационные данные",
    cancel: "Отмена",
    update: "Обновить",
    save: "Сохранить",
    selectPersonType: "Выберите тип лица",
    realPerson: "Физическое лицо",
    legalPerson: "Юридическое лицо",
    phone: "Мобильный телефон",
    landline: "Стационарный телефон",
    fatherName: "Имя отца",
    nationalCode: "Национальный код",
    idNumber: "Номер удостоверения",
    birthday: "Дата рождения",
    placeOfBirth: "Место рождения",
    postalCode: "Почтовый индекс",
    email: "Электронная почта",
    introduction: "Как вы о нас узнали",
    nationalCodePic: "Фото национальной карты",
    plaque: "Номер дома",
    address: "Полный адрес",
    companyName: "Название компании/магазина",
    registrationNumber: "Регистрационный номер",
    economicCode: "Экономический код",
    organizationIdentity: "Национальный идентификатор организации",
    companyType: "Тип компании",
    activity: "Сфера деятельности",
    registrationAd: "Изображение объявления о регистрации",
    lastPublishedAd: "Изображение последнего официального объявления",
    statute: "Изображение устава компании",
    agentLetterPic: "Изображение письма о назначении представителя",
    successMessage: "Успешно сохранено",
    errorSelectType: "Пожалуйста, выберите один из вариантов.",
    rules: {
      companyName: "Поле названия компании/магазина обязательно.",
      registrationNumber: "Поле регистрационного номера обязательно.",
      economicCode: "Поле экономического кода обязательно.",
      organizationIdentity:
        "Поле национального идентификатора организации обязательно.",
      registrationAd: "Поле изображения объявления о регистрации обязательно.",
      lastPublishedAd:
        "Поле изображения последнего официального объявления обязательно.",
      telephone: "Поле стационарного телефона обязательно.",
      fatherName: "Поле имени отца обязательно.",
      nationalCode: "Поле национального кода обязательно.",
      birthday: "Поле даты рождения обязательно.",
      idNumber: "Поле номера удостоверения обязательно.",
      placeOfBirth: "Поле места рождения обязательно.",
      postalCode: "Поле почтового индекса обязательно.",
      nationalCodePic: "Поле фото национальной карты обязательно.",
      address: "Поле полного адреса обязательно.",
      plaque: "Поле номера дома обязательно.",
    },
    companyTypes: {
      governmental: "Государственная",
      private: "Частная",
      commonStock: "Публичная акционерная",
      specialStock: "Закрытая акционерная",
    },
  },
  changePassword: {
    title: "Смена пароля",
    description: "Измените пароль своей учётной записи",
    cancel: "Отмена",
    update: "Обновить",
    passwordInstructions: {
      forgotPassword:
        "Если вы ещё не устанавливали пароль, нажмите «Забыли пароль».",
      passwordRequirements:
        "Пароль должен содержать минимум 8 символов, включая цифры, прописные и строчные буквы латинского алфавита и специальные символы.",
      passwordPrivacy: "Не передавайте пароль третьим лицам.",
      keyboardLanguage:
        "Убедитесь, что при вводе пароля включена английская раскладка клавиатуры.",
    },
    currentPassword: "Текущий пароль",
    newPassword: "Новый пароль",
    confirmNewPassword: "Повторите новый пароль",
    addOrForgotPassword: "Добавить или забыли пароль",
    changePasswordWithCode: "Смена пароля по номеру",
    close: "Закрыть",
    change: "Изменить",
    enterCode: "Введите код",
    successMessage: "Пароль успешно обновлён",
    invalidCode: "Неверный код.",
    tooManyAttempts: "Слишком много попыток!",
    rules: {
      required: "Поле обязательно для заполнения.",
      min: "Пароль должен содержать не менее 8 символов",
      equal: "Пароли не совпадают",
      number: "Введите корректный номер",
    },
  },
  router: {
    dashboard: "Վահանակ",
    contacts: "Հաճախորդների ակումբ",
    editContact: "Խմբագրել հաճախորդին",
    createContact: "Ստեղծել հաճախորդ",
    customers: "Հաճախորդների ցուցակ",
    contactList: "Կոնտակտ օգնական",
    messages: "Հաղորդագրություններ",
    messageCategories: "Հաղորդագրությունների կատեգորիաներ",
    oldTransactions: "Հին գործարքներ",
    yourTransactions: "Ձեր գործարքները",
    buyPanel: "Գնել պանել",
    permissions: "Թույլտվություններ",
    createPermission: "Ստեղծել թույլտվություն",
    invitations: "Իմ հրավերների ցուցակ",
    editUser: "Խմբագրել օգտատիրոջը",
    userInformation: "Դիտել օգտատիրոջ տվյալները",
    walletEdit: "Խմբագրել օգտատիրոջ դրամապանակը",
    userHistory: "Օգտատիրոջ պատմություն",
    userNotificationsHistory: "Օգտատերերի ծանուցումների պատմություն",
    notifications: "Ծանուցումներ",
    createNotification: "Ստեղծել ծանուցում",
    editNotification: "Խմբագրել ծանուցումը",
    adminNotifications: "Ադմինի ծանուցումներ",
    yourNotifications: "Ձեր ծանուցումները",
    adminNotificationsList: "Մենեջերի ծանուցումներ",
    tickets: "Տոմսեր",
    createTicket: "Գրանցել նոր տոմս",
    editTicket: "Խմբագրել տոմսը",
    departments: "Բաժիններ",
    createDepartment: "Նոր բաժին",
    editDepartment: "Խմբագրել բաժինը",
    adminTickets: "Տոմսերի կառավարում",
    discounts: "Զեղչեր",
    createDiscount: "Ստեղծել զեղչ",
    editDiscount: "Խմբագրել զեղչը",
    workReports: "Աշխատանքային հաշվետվություններ",
    createWorkReport: "Ստեղծել աշխատանքային հաշվետվություն",
    callMonitoring: "Զանգերի մոնիթորինգ",
    adminWorkReports: "Աշխատանքային հաշվետվությունների կառավարում",
    editWorkReport: "Դիտել և խմբագրել հաշվետվությունը",
    packProperties: "Փաթեթի հատկություններ",
    createPackProperty: "Ստեղծել փաթեթի հատկություն",
    editPackProperty: "Խմբագրել փաթեթի հատկությունը",
    panels: "Պանելներ",
    createPanel: "Ստեղծել պանել",
    editPanel: "Խմբագրել պանելը",
    transferRequests: "Հաշվից դուրսբերման հայտեր",
    editTransferRequest: "Խմբագրել դուրսբերման հայտը",
    tariffs: "Սակագներ",
    createTariff: "Ստեղծել սակագին",
    editTariff: "Խմբագրել սակագինը",
    requests: "Հայտեր",
    viewUser: "Դիտել օգտատիրոջը",
    manageTransactions: "Գործարքների կառավարում",
    viewTransaction: "Դիտել գործարքը",
    manageConfigs: "Կարգավորումների կառավարում",
    rbLandConfigs: "Robot Land կարգավորումների կառավարում",
    editConfig: "Խմբագրել կարգավորումները",
    manageUsers: "Օգտատերերի կառավարում",
    categories: "Կատեգորիաներ",
    createCategory: "Ավելացնել կատեգորիա",
    editCategory: "Խմբագրել կատեգորիան",
    content: "Բովանդակություն",
    createContent: "Ավելացնել բովանդակություն",
    editContent: "Խմբագրել բովանդակությունը",
    addUserGuide: "Ավելացնել օգտատիրոջ ուղեցույց",
    editUserGuide: "Խմբագրել ուղեցույցը",
    roles: "Դերեր",
    editRole: "Խմբագրել դերը",
    createRole: "Ավելացնել դեր",
    permissionTitle: "Թույլտվություններ",
    paymentGateways: "Վճարային դարպասներ",
    editPaymentGateway: "Խմբագրել վճարային դարպասը",
    campaigns: "Արշավներ",
    createCampaign: "Ստեղծել արշավ",
    editCampaign: "Խմբագրել արշավի տվյալները",
    adminCustomers: "Հաճախորդներ",
    createCustomer: "Ստեղծել հաճախորդ",
    editCustomerInfo: "Խմբագրել հաճախորդի տվյալները",
    referrerCustomers: "Հրավիրած հաճախորդներ",
    customerHistory: "Հաճախորդի պատմություն",
    userProfile: "Օգտատիրոջ պրոֆիլ",
    editProfile: "Խմբագրել պրոֆիլը",
    inviteFriends: "Հրավիրել ընկերներին",
    personalInfo: "Անձնական տվյալներ",
    editPersonalInfo: "Խմբագրել տվյալները",
    changePassword: "Փոխել գաղտնաբառը",
    newWallet: "Նոր դրամապանակ",
  },
  profileView: {
    email: "Էլ. փոստ",
    balance: "Մնացորդ",
    personType: "Անձի տեսակ",
    currency: "Ռիալ",
    unknown: "----",
  },
  panelInfoProfile: {
    panelTitle: "Դուք ունեք {title} պանել՝ {days} օրյա ժամկետով։",
    buyOrRenew:
      "Պանել գնելու կամ երկարաձգելու համար սեղմեք ստորև բերված կոճակը։",
    buyPanel: "Գնել պանել",
    percentage: "%",
  },
  profileSetting: {
    cardTitle: "Պրոֆիլի կարգավորումներ",
    changePasswordTitle: "Փոխել մուտքի գաղտնաբառը",
    changePasswordSubtitle: "Փոխեք Ձեր հաշվի մուտքի գաղտնաբառը։",
    alertMessage:
      "Եթե դեռ գաղտնաբառ չեք սահմանել, ակտիվացրեք «Գաղտնաբառի գրանցում» տարբերակը։",
    currentPasswordLabel: "Ընթացիկ գաղտնաբառ",
    setPasswordLabel: "Գրանցել գաղտնաբառ",
    addPassword: "Ավելացնել գաղտնաբառ",
    newPasswordLabel: "Նոր գաղտնաբառ",
    repeatPasswordLabel: "Կրկնել գաղտնաբառը",
    saveChanges: "Պահպանել փոփոխությունները",
    currentPasswordPlaceholder: "Ընթացիկ գաղտնաբառ",
    newPasswordPlaceholder: "Նոր գաղտնաբառ",
    repeatPasswordPlaceholder: "Կրկնել գաղտնաբառը",
  },
  profileOrders: {
    cardTitle: "Պատվերներ",
    openOrders: "Բաց պատվերներ ({count})",
    closedOrders: "Փակված պատվերներ ({count})",
    noOrders: "Դուք դեռ պատվեր չունեք",
  },
  personalInformation: {
    cardTitle: "Անձնական հաշվի տվյալներ",
    cardSubtitle: "Թարմացրեք Ձեր անձնական տվյալները։",
    cancel: "Չեղարկել",
    update: "Թարմացնել",
    yourInfo: "Ձեր տվյալները",
    profilePicture: "Պրոֆիլի նկար",
    allowedFileTypes: "Թույլատրված ֆայլերի տեսակներ՝ png, jpg, jpeg:",
    pictureSize: "Պրոֆիլի նկարը պետք է լինի քառակուսի (օրինակ՝ 480 × 480):",
    name: "Անուն",
    lastName: "Ազգանուն",
    username: "Մուտքանուն",
    receiveSMS: "Ստանալ SMS",
    smsCostNote: "Ակտիվացնելու դեպքում SMS-ների արժեքը կհանվի Ձեր հաշվից։",
    phoneNumber: "Բջջային համար",
    phonePlaceholder: "Բջջային համար",
    email: "Էլ. փոստ",
    emailPlaceholder: "Էլ. փոստ",
    emailPrivacy: "Մենք երբեք չենք կիսվի Ձեր էլ. փոստը երրորդ անձանց հետ։",
    successMessage: "Պրոֆիլը հաջողությամբ թարմացվել է։",
  },
  userInfoForm: {
    companyName: "Ընկերության/խանութի անվանումը",
    registrationNumber: "Գրանցման համար",
    economicCode: "Տնտեսական կոդ",
    organizationIdentity: "Կազմակերպության ազգային համար",
    companyType: "Ընկերության տեսակ",
    activity: "Գործունեության ոլորտ",
    registrationAd: "Ընկերության գրանցման հայտարարության պատկեր",
    lastPublishedAd: "Վերջին պաշտոնական հայտարարության պատկեր",
    statute: "Ընկերության կանոնադրության պատկեր",
    argentLetterPic: "Ներկայացուցչի ներկայացման նամակի պատկեր",
    phone: "Բջջային համար",
    telephone: "Հեռախոսահամար (ֆիքսված)",
    fatherName: "Հոր անունը",
    nationalCode: "Ազգային կոդ",
    id: "Անձնագրի համար",
    birthday: "Ծննդյան ամսաթիվ",
    placeBirthday: "Ծննդավայր",
    postalCode: "Փոստային ինդեքս",
    email: "Էլ. փոստ",
    introduction: "Ինչպե՞ս եք ծանոթացել մեզ հետ",
    nationalCodePic: "Ազգային քարտի լուսանկար",
    plaque: "Տան համար",
    address: "Ամբողջական հասցե",
    companyTypes: {
      governmental: "Պետական",
      private: "Մասնավոր",
      common_stock: "Հանրային բաժնետիրական",
      special_stock: "Փակ բաժնետիրական",
    },
    rules: {
      companyName: "Ընկերության անվանման դաշտը պարտադիր է։",
      registration_number: "Գրանցման համարի դաշտը պարտադիր է։",
      economic_code: "Տնտեսական կոդի դաշտը պարտադիր է։",
      organization_identity: "Կազմակերպության ազգային համարի դաշտը պարտադիր է։",
      registration_ad: "Գրանցման հայտարարության պատկերի դաշտը պարտադիր է։",
      last_published_ad:
        "Վերջին պաշտոնական հայտարարության պատկերի դաշտը պարտադիր է։",
      telephone: "Ֆիքսված հեռախոսի դաշտը պարտադիր է։",
      fatherName: "Հոր անունի դաշտը պարտադիր է։",
      nationalCode: "Ազգային կոդի դաշտը պարտադիր է։",
      id: "Անձնագրի համարի դաշտը պարտադիր է։",
      birthday: "Ծննդյան ամսաթվի դաշտը պարտադիր է։",
      placeBirthday: "Ծննդավայրի դաշտը պարտադիր է։",
      postalCode: "Փոստային ինդեքսի դաշտը պարտադիր է։",
      nationalCodePic: "Ազգային քարտի լուսանկարի դաշտը պարտադիր է։",
      address: "Հասցեի դաշտը պարտադիր է։",
      plaque: "Տան համարի դաշտը պարտադիր է։",
    },
  },
  createUserForm: {
    name: "Անուն",
    lastName: "Ազգանուն",
    nid: "Ազգային կոդ",
    phone: "Բջջային համար",
    create: "Ստեղծել",
    errors: {
      nameRequired: "Անունը մուտքագրված չէ!",
      lastNameRequired: "Ազգանունը մուտքագրված չէ!",
      nidRequired: "Ազգային կոդը մուտքագրված չէ!",
      phoneRequired: "Հեռախոսահամարը մուտքագրված չէ!",
    },
  },
  lastView: {
    cardTitle: "Ձեր վերջին այցելությունները",
    cardSubtitle: "Ձեր վերջին այցելությունները մեր էջերին",
    tableHeaders: {
      page: "Էջ",
      address: "Հասցե",
      enterDate: "Մուտքի ամսաթիվ",
      leaveDate: "Ելքի ամսաթիվ",
      timeSpent: "Այս էջում անցկացրած ժամանակը",
    },
    viewAll: "Դիտել բոլորը",
    timeUnit: "րոպե",
    pages: {
      home: "Գլխավոր",
      panels: "Պանելներ",
      profile: "Լրացնել պրոֆիլը",
    },
  },
walletWidget: {
  title: "Последние транзакции",
  balanceLabel: "Ваш баланс:",
  viewTransactions: "Посмотреть транзакции",
  transactionTypes: {
    withdraw: "Вывод средств",
    deposit: "Пополнение",
    charge: "Пополнение кошелька",
    refund: "Возврат средств",
    default: "Транзакция",
    adminCharge: "Корректировка администратором",
    agency: "Комиссия агентства",
  },
},
  panelWidget: {
    title: "Դուք ունեք {title} պանել՝ {days} օրյա ժամկետով։",
    renewPrompt:
      "Պանել գնելու կամ երկարաձգելու համար սեղմեք ստորև բերված կոճակը։",
    buyPanel: "Գնել պանել",
    percentage: "{value}%",
    infinity: "∞",
    days: "{count} օր",
  },
  component: {
    title: "Ձեր հրավիրած օգտատերերը",
    columns: {
      row: "Հերթական համար",
      name: "Անուն",
      family: "Ազգանուն",
      username: "Մուտքանուն",
      phone: "Բջջային համար",
      created_at: "Գրանցման ամսաթիվ",
      actions: "Գործողություններ",
    },
    unknown: "Անհայտ",
    error: "Սխալ",
    breadcrumb: "Հրավիրված օգտատերեր",
  },
  table: {
    itemsPerPage: "Տողերի քանակը մեկ էջում",
    pageText: "Ցուցադրվում է {0}-ից {1} մինչև {2} գրառում",
    prevText: "Նախորդ",
    nextText: "Հաջորդ",
    noDataText: "Տվյալներ չկան",
    search: "Որոնք",
  },
  UserHistory: {
    title: "Օգտատերերի պատմություն",
    add_history: "Գրանցել նոր պատմություն",
    send_message: "Ուղարկել հաղորդագրություն",
    close: "Փակել",
    save: "Պահպանել",
    cancel: "Չեղարկել",
    new_history_dialog_title: "Գրանցել նոր պատմություն",
    send_message_dialog_title: "Ուղարկել հաղորդագրություն",
    negotiations: "Կատարված բանակցություններ",
    follow_up: "Հաջորդ զանգի հետևման կետեր",
    success_history: "Պատմությունը հաջողությամբ գրանցվել է։",
    success_message: "Հաղորդագրությունն ուղարկվել է հաջողությամբ։",
    columns: {
      id: "Համար",
      title: "Վերնագիր",
      status: "Փուլ",
      current_time_date: "Վերջին զանգի ամսաթիվ",
      current_time_hour: "Վերջին զանգի ժամ",
      next_time_date: "Հաջորդ զանգի ամսաթիվ",
      next_time_hour: "Հաջորդ զանգի ժամ",
      user_id: "Աջակցություն",
      actions: "Գործողություններ",
    },
    table: {
      itemsPerPage: "Տողերի քանակը մեկ էջում",
      pageText: "Ցուցադրվում է {0}-ից {1} մինչև {2} գրառում",
      prevText: "Նախորդ",
      nextText: "Հաջորդ",
      noDataText: "Տվյալներ չկան",
      search: "Որոնք",
    },
    form: {
      title: "Վերնագիր",
      status: "Փուլ",
      current_time: "Վերջին զանգի ամսաթիվ",
      description: "Նկարագրություն",
      next_time: "Հաջորդ զանգի ամսաթիվ",
      pursue_text: "Հետևման տեքստ",
      category: "Ընտրել կատեգորիա",
      message_title: "Հաղորդագրության վերնագիր",
    },
  },
  newUserTransactions: {
    userWallet: "Օգտատիրոջ դրամապանակ",
    transactionList: "Գործարքների ցուցակ",
    userTransactions: "Օգտատիրոջ գործարքները",
    terminal: "Տերմինալ",
    liveSms: "Կենդանի SMS",
    realEstateNews: "Divar-ի թարմ նորություններ",
    rial: "Ռիալ",
    row: "Հերթական համար",
    uniqueId: "Համար",
    amount: "Գումար",
    time: "Ժամ",
    createdAt: "Ամսաթիվ",
    description: "Լրացուցիչ նկարագրություն",
    type: "Գործարքի տեսակ",
    product_description: "Նկարագրություն",
    serviceId: "Ծառայության անվանում",
    balanceAfter: "Մնացորդը գործարքից հետո",
    perPage: "Քանակ",
    search: "Որոնել",
    balance: "Մնացորդ",
    transactionListTooltip: "Գործարքների ցուցակ",
    panelLogin: "Մուտք պանել",
    history: "Պատմություն",
    error: {
      terminalWallet: "Սխալ տերմինալի դրամապանակի ստացման ժամանակ",
    },
    transactionType: "Գործարքի տեսակ",
    service: "Ծառայություն",
    dateFrom: "Ամսաթիվը՝ սկսած",
    dateTo: "մինչև ամսաթիվ",
    oldWallet: "Հին դրամապանակ",
    depositReceipt: "Մուտքագրման անդորրագիր",
    showReceipt: "Ցուցադրել անդորրագիրը",
    transactionTypes: {
      online: "Առցանց",
      admin: "Ադմինի կողմից",
      refund: "Ուղղիչ գործարք",
      agency: "Գործակալություն",
      withdraw: "Դուրսբերում",
      deposit: "Մուտքագրում",
      adminCharge: "Գործարք ադմինի կողմից",
      charge: "Դրամապանակի լիցքավորում",
      refund: "Վերադարձ",
    },
    error: {
      imageLoad: "Պատկերի բեռնման սխալ!",
    },
  },
  buyPanel: {
    alert: {
      choosePanel: "Խնդրում ենք ուշադիր ընտրել պանելի տեսակը!",
    },
    dialog: {
      title: "Գնել պանել",
      confirmPurchase: "Համոզվա՞ծ եք, որ ցանկանում եք գնել {title} պանելը։",
      discountCodeLabel: "Զեղչի կոդ",
      discountCodePlaceholder: "Մուտքագրեք Ձեր զեղչի կոդը",
      applyDiscount: "Գրանցել կոդը",
      purchase: "Գնել",
      iHaveDiscount: "Ես ունեմ զեղչի կոդ",
    },
    toast: {
      discountApplied: "Զեղչի կոդը հաջողությամբ կիրառվել է!",
      purchaseSuccess: "Փաթեթը հաջողությամբ գնվել է",
      error: "Տեղի է ունեցել սխալ՝ {message}",
      unauthorized: "Խնդրում ենք նախ մուտք գործել",
      validationError: "Ստուգման սխալ՝ {message}",
    },
    currency: "Ռիալ",
  },
  panelCard: {
    rial: "Ռիալ",
    days: "օր",
    buyPanel: "Գնել պանել",
  },
  cons: {
    title: "Ընտրել էմոջի",
  },
  cons1: {
    title: "Լռելյայն տեքստ",
  },
  MENUS: {
    AD_TERMINAL_SYSTEM: "Մեծ գովազդային տերմինալային համակարգ",
  },
};
